import assign from "../assign/index.js";
export default function cloneObject(object) {
  return assign({}, object);
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@contently/toolkit/node_modules/date-fns/esm/_lib/cloneObject/index.js
// module id = null
// module chunks = 